import { render, staticRenderFns } from "./profile-view-critical-task.vue?vue&type=template&id=a07f0128&scoped=true"
import script from "./profile-view-critical-task.vue?vue&type=script&lang=js"
export * from "./profile-view-critical-task.vue?vue&type=script&lang=js"
import style0 from "./profile-view-critical-task.vue?vue&type=style&index=0&id=a07f0128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a07f0128",
  null
  
)

export default component.exports